"use strict";
// packages/types/src/record.ts
Object.defineProperty(exports, "__esModule", { value: true });
